import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import Button from "ds/Button";
import { Tooltip } from "ds/Tooltip";
import { selectDeploymentTargetEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import * as S from "./DeactivateEnvSection.style";

const bullets = [
  "status_active_delete_bullet_1",
  "status_active_delete_bullet_2",
  "status_active_delete_bullet_3"
];
interface DeactivateEnvSectionProps {
  openDeactivateConfirm: () => void;
  isAdmin: boolean;
  environmentTarget: string;
}

export const DeactivateEnvSection = ({
  openDeactivateConfirm,
  isAdmin,
  environmentTarget
}: DeactivateEnvSectionProps) => {
  const enableDeploymentTarget = useAppSelector(selectDeploymentTargetEnabled);

  const notLocalDeploymentTarget =
    environmentTarget !== "local" && enableDeploymentTarget;

  const intl = useIntl();

  return (
    <S.Border>
      <S.TextWrapper>
        <S.WarningText>
          {intl.formatMessage({
            id: "deactivate_environment"
          })}
        </S.WarningText>
        <S.WarningWrapper>
          <S.WarningIcon color="var(--icon-gold-fill,var(--gold))" />
          <Typography.BodyText size="small">
            {intl.formatMessage({
              id: "status_active_delete_warning"
            })}
          </Typography.BodyText>
        </S.WarningWrapper>
        <Typography.BodyText size="small">
          {intl.formatMessage({
            id: "status_active_delete_bullets_title"
          })}
        </Typography.BodyText>
        <S.List>
          {bullets.map((bullet, index) => (
            <li key={index}>
              <Typography.BodyText size="small">
                {intl.formatMessage({
                  id: bullet
                })}
              </Typography.BodyText>
            </li>
          ))}
        </S.List>
        {!isAdmin ? (
          <Tooltip
            tooltip={intl.formatMessage({
              id: `no_access_environment_decativate${
                notLocalDeploymentTarget ? "_local_target" : ""
              }`
            })}
            analyticId={`no_access_environment_decativate${
              notLocalDeploymentTarget ? "_local_target" : ""
            }`}
          >
            <Button
              analyticId="deactivate_environment.button"
              variant="primary"
              onClick={openDeactivateConfirm}
              type="button"
              disabled
              aria-label={intl.formatMessage({
                id: `no_access_environment_decativate${
                  notLocalDeploymentTarget ? "_local_target" : ""
                }`
              })}
            >
              {intl.formatMessage({ id: "deactivate_environment.button" })}
            </Button>
          </Tooltip>
        ) : (
          <Button
            variant="primary"
            onClick={openDeactivateConfirm}
            type="button"
            aria-label={intl.formatMessage({
              id: "deactivate_environment.button"
            })}
            analyticId="deactivate_environment.button"
          >
            {intl.formatMessage({ id: "deactivate_environment.button" })}
          </Button>
        )}
      </S.TextWrapper>
    </S.Border>
  );
};
